import { render, staticRenderFns } from "./column2.vue?vue&type=template&id=2434b47e&scoped=true&"
import script from "./column2.vue?vue&type=script&lang=js&"
export * from "./column2.vue?vue&type=script&lang=js&"
import style0 from "./column2.vue?vue&type=style&index=0&id=2434b47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434b47e",
  null
  
)

export default component.exports